import { render, staticRenderFns } from "./ReFeral.vue?vue&type=template&id=edc5a8ae&scoped=true"
import script from "./ReFeral.vue?vue&type=script&lang=js"
export * from "./ReFeral.vue?vue&type=script&lang=js"
import style0 from "./ReFeral.vue?vue&type=style&index=0&id=edc5a8ae&prod&scoped=true&lang=css"
import style1 from "./ReFeral.vue?vue&type=style&index=1&id=edc5a8ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc5a8ae",
  null
  
)

export default component.exports